<template>
  <nx-fullscreen-dialog
    :title="title"
    :active="active"
    @dismiss="dismiss"
    classes="fill-height"
  >

    <template slot="toolbar-items">
      <v-btn
        color="accent"
        dark flat
        @click="create"
        :loading="loading"
        :disabled="loading || !flags.valid || step !== STEP_EDIT_PAGE_POSITION_FIELDS"
      >
        {{ $t('message.milenium.send') }}
      </v-btn>
    </template>


    <v-container class="milenium-wizard" v-if="active">
      <v-layout wrap fill-height>
        <v-flex>
          <v-stepper v-model="step" color="info" class="elevation-0">
            <v-stepper-header class="elevation-0">
              <v-stepper-step
                color="info"
                :step="STEP_SELECT_PAGE"
                :complete="step > STEP_SELECT_PAGE"
                :editable="step > STEP_SELECT_PAGE"
              >
                {{ $t('message.milenium.destinationPage') }}
              </v-stepper-step>
              <v-divider></v-divider>

              <v-stepper-step
                color="info"
                :step="STEP_SELECT_PAGE_POSITION"
                :complete="step > STEP_SELECT_PAGE_POSITION"
                :editable="step > STEP_SELECT_PAGE_POSITION"
              >
                {{ $t('message.milenium.destinationContent') }}
              </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step
                color="info"
                :step="STEP_EDIT_PAGE_POSITION_FIELDS"
              >
                {{ $t('message.milenium.contentFields') }}
              </v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content :step="STEP_SELECT_PAGE" class="py-0">
                <nx-wizard-step-page @input="handlePageSelection"></nx-wizard-step-page>
              </v-stepper-content>

              <v-stepper-content :step="STEP_SELECT_PAGE_POSITION"  class="py-0">
                <nx-wizard-step-page-position v-if="page && planilloId"
                                           :page="page"
                                           :planillo-id="planilloId"
                                           @input="handlePagePositionSelection"
                ></nx-wizard-step-page-position>
              </v-stepper-content>

              <v-stepper-content :step="STEP_EDIT_PAGE_POSITION_FIELDS" class="py-0">
                <nx-wizard-step-page-position-fields v-if="positionId"
                                                     v-model="draft"
                                                     @form="flags = $event"
                                                     :content-id="contentId"
                                                     :publication-id="publicationId"
                                                     :publication-type-id="publicationTypeId"
                                                     :position-id="positionId"
                ></nx-wizard-step-page-position-fields>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-flex>
      </v-layout>
    </v-container>

  </nx-fullscreen-dialog>
</template>

<script>
import api from '@/modules/milenium/api';
import NxFullscreenDialog from '@/components/dialogs/FullscreenDialog';
import NxWizardStepPage from '@/modules/milenium/components/wizard/steps/WizardStepPage';
import NxWizardStepPagePosition from '@/modules/milenium/components/wizard/steps/WizardStepPagePosition';
import NxWizardStepPagePositionFields from '@/modules/milenium/components/wizard/steps/WizardStepPagePositionFields';

const STEP_SELECT_PAGE = 1;
const STEP_SELECT_PAGE_POSITION = 2;
const STEP_EDIT_PAGE_POSITION_FIELDS = 3;

export default {
  extends: NxFullscreenDialog,
  props: {
    contentId: {
      type: Number,
      required: true,
    },
  },
  components: {
    NxWizardStepPage,
    NxWizardStepPagePosition,
    NxWizardStepPagePositionFields,
    NxFullscreenDialog,
  },
  data() {
    return {
      STEP_SELECT_PAGE,
      STEP_SELECT_PAGE_POSITION,
      STEP_EDIT_PAGE_POSITION_FIELDS,
      step: STEP_SELECT_PAGE,
      loading: false,
      planilloId: null,
      page: {},
      pagePosition: {},
      flags: {},
      draft: {},
    };
  },
  computed: {
    publicationId() {
      return this.pagePosition.publicationId || null;
    },
    publicationTypeId() {
      return this.pagePosition.publicationTypeId || null;
    },
    positionId() {
      return this.pagePosition.articleId || null;
    },
  },
  methods: {
    reset() {
      this.loading = false;
      this.step = STEP_SELECT_PAGE;
      this.page = {};
      this.pagePosition = {};
      this.flags = {};
    },
    dismiss() {
      this.reset();
      this.$emit('dismiss');
    },
    handlePageSelection({ planilloId, page }) {
      this.planilloId = planilloId;
      this.page = page;
      this.step = STEP_SELECT_PAGE_POSITION;
    },
    handlePagePositionSelection(pagePosition) {
      this.pagePosition = pagePosition;
      this.step = STEP_EDIT_PAGE_POSITION_FIELDS;
    },
    async create() {
      this.loading = true;
      try {
        const position = await api.createContentPagePosition(
          this.contentId,
          this.publicationTypeId,
          this.publicationId,
          this.positionId,
          this.draft,
        );
        location.reload();
      } catch (error) {
        console.error('Error creating content position', {
          content: this.contentId,
          publicationTypeId: this.publicationTypeId,
          publicationId: this.publicationId,
          positionId: this.positionId,
          payload: this.draft,
        });
        this.loading = false;
      }
    },
  },
};
</script>
